<template>
    <form @submit.prevent="fakeSubmit">
        <div v-for="(step, x) in steps" v-bind:key="x">
            <h4 v-if="currentFormStepId == step.id">{{step.title}}</h4>
            <form-builder class="form-step" v-bind:class="{ 'show': currentFormStepId == step.id }" v-model="answers[step.id]" :builder="step.fields" :formAnswers="answers" :errors="errors"/>
        </div>
<!--        <div class="input-box" >-->
<!--            <div class="checkbox-text" v-if="currentFormStepId == lastFormStep">-->
<!--                <input id="accept_terms" type="checkbox" v-model="accept_terms" value="1"/>-->
<!--                <p for="accept_terms">-->
<!--                    Declaro estar ciente sobre a utilização das minhas amostras e informações clínicas para fins de pesquisa que-->
<!--                    colaborem para o-->
<!--                    melhor entendimento da doença. Estou ciente de que minha privacidade será respeitada, ou seja, meu nome ou-->
<!--                    qualquer informação-->
<!--                    que possa me identificar serão mantidos em sigilo.-->
<!--                </p>-->
<!--            </div>-->
<!--            <div class="form-error">-->
<!--                <small class="error" v-if="errors && errors.accept_terms">{{errors.accept_terms.join()}}</small>-->
<!--                <small class="error" v-if="errors && errors['required']">{{errors['required']}}</small>-->
<!--            </div>-->
<!--        </div>-->
        <div class="flex-buttons">
            <button class="button item-btn" @click="returnStep()" :disabled="currentFormStepId == firstFormStep" v-if="!loading && !loadingScreen" >Voltar</button>
            <button class="button btn-primary" @click="nextStep()" v-if="!loading && !loadingScreen && (currentFormStepId != lastFormStep)" >Próximo</button>
            <button class="button btn-primary" @click="handleSubmit()" v-if="!loading && !loadingScreen && (currentFormStepId == lastFormStep)" >Salvar e Próximo</button>
            <button class="button btn-primary full" disabled v-if="loading"><loading/></button>
        </div>
        <loading-screen v-if="loadingScreen" />
    </form>
</template>

<script>
    import moment from 'moment'
    import { parse } from '@fortawesome/fontawesome-svg-core';
    import { GET_FORM } from "../../services/form"

    import DisplayRulesFunctions from '../FormBuilder/DisplayRulesFunctions';
    import FormBuilder from '../FormBuilder/FormBuilder';

    export default {
        components: {FormBuilder},
        props: ['kit_type'],
        name: "FormSteps",
        data(){
            return {
                currentFormStep: 0,
                currentFormStepId: null,
                firstFormStep: null,
                lastFormStep: null,
                steps: [],
                answers: {},
                errors: {},
                loading: false,
                loadingScreen: true,
                accept_terms: true,
            }
        },
        mounted() {
            this.loadForm();
        },
        methods: {
            nextStep() {
                if(!this.validateStep(this.steps[this.currentFormStep].id))
                    return false;

                this.currentFormStep += 1;
                this.currentFormStepId = this.steps[this.currentFormStep].id;
                this.$emit('formNextStep');
                window.scrollTo(0, 0);
            },
            returnStep() {
                this.errors = [];
                this.currentFormStep -= 1;
                this.currentFormStepId = this.steps[this.currentFormStep].id;
                this.$emit('formNextStep', false);
                window.scrollTo(0, 0);
            },
            async loadForm() {
                try {
                    const data = await GET_FORM(this.kit_type);
                    data.steps.map(step => {
                        const auxForm = {};
                        const mapFields = step.fields.map(field => auxForm[field.id] = (field.type == "multiselect" ? [] : field.type == "imc" ? {heigth: '', weigth: ''} : field.type == "datetime" ? {date: "", time: ""} : ""))
                        this.answers[step.id] = auxForm;
                    })
                    this.steps = data.steps;
                    this.steps.forEach((step, x) => {
                        if(step.title == 'Riscos do exame CLC')
                            this.steps.splice(x, 1);
                    })
                    this.currentFormStepId = this.steps[0].id;
                    this.firstFormStep = this.currentFormStepId;
                    this.lastFormStep = this.steps[this.steps.length - 1].id;
                    this.$emit('setFormSteps', this.steps);
                } catch(error){
                    console.log(error);
                } finally {
                    this.loadingScreen = false;
                }
            },
            validateStep(id) {
                let ret = true;
                this.errors = [];
                let step = {};
                this.steps.forEach(formStep => {
                    if(formStep.id == id)
                        step = formStep;
                });
                let answers = Object.keys(this.answers).map((key) => [key, this.answers[key]]);
                answers.forEach(answer => {
                    if(answer[0] == id) {
                        answers = answer[1];
                        answers = Object.keys(answers).map((key) => [key, answers[key]]);
                    }
                });
                answers.forEach(answer => {
                    if(typeof answer[1] === 'object') {
                        if(answer[1].heigth == '') {
                            this.errors['height'] = "Campo obrigatório";
                            ret = false;
                        }
                        if(answer[1].weigth == '') {
                            this.errors['weight'] = "Campo obrigatório";
                            ret = false;
                        }
                        if(answer[1].date == '') {
                            this.errors['date'] = "Campo obrigatório";
                            ret = false;
                        } else if(answer[1].date && answer[1].date.length < 10){
                            this.errors['date'] = "Data incompleta";
                            ret = false;
                        }else {
                            try {
                                let dateIsValid = moment(answer[1].date, 'DD/MM/YYYY', true).isValid();
                                let splDate = answer[1].date.split('/');
                                let parsedDate = Date.parse(splDate[2] + ',' + splDate[1] + ',' + splDate[0]);
                                if(!dateIsValid){
                                    this.errors['date'] = "Data inválida";
                                    ret = false;
                                } else if(parsedDate > Date.now()){
                                    this.errors['date'] = "Data futura inválida";
                                    ret = false;
                                }

                            } catch (error) {
                                console.log(error);
                            }
                        }
                        if(answer[1].time == '') {
                            this.errors['time'] = "Campo obrigatório";
                            ret = false;
                        } else if(answer[1].time && answer[1].time.length < 5){
                            this.errors['time'] = "Horário inválido";
                            ret = false;
                        } else {
                            try {
                                var hour = answer[1].time.replace(':', '');
                                hour = parseInt(hour);
                                if(hour > 2359){
                                    this.errors['time'] = "Horário inválido";
                                    ret = false;
                                }
                            } catch (error) {
                                console.log(error);
                            }
                        }
                    }
                    if(answer[1] == "" && this.isValid(answer[0])) {
                        this.errors[answer[0]] = "Campo obrigatório";
                        ret = false;
                    }
                })
                if(!ret)
                    this.errors['required'] = "Por favor, responda todas as perguntas obrigatórias.";

                return ret;
            },
            isValid(id) {
                let ret = true;
                this.steps.forEach(step => {
                    step.fields.forEach(field => {
                        let bypass = false;
                        if(id == field.id && (field.type == 'label' || field.type == 'title')){
                            ret = false;
                            bypass = true;
                        }
                        if(id == field.id && field.title == 'Se já foi administrada a segunda dose, informe a data aqui:'){
                            ret = false;
                            bypass = true;
                        }
                        if(id == field.id && field.title == 'Você é portador de quais doenças ou condições abaixo?'){
                            ret = false;
                            bypass = true;
                        }
                        if(id == field.id && field.title == 'Tem alguma das doenças ou condições abaixo?'){
                            ret = false;
                            bypass = true;
                        }
                        if(id == field.id && field.title == 'Você está grávida?'){
                            ret = false;
                            bypass = true;
                        }
                        if(id == field.id && field.title == 'Selecione abaixo as situações que se encaixam na sua rotina'){
                            ret = false;
                            bypass = true;
                        }
                        if(id == field.id && field.display_rules.length > 0 && !bypass){
                            let answers = this.answers;
                            field.display_rules.map(rule => {
                                ret = DisplayRulesFunctions[rule.value_of_type](rule, answers, this.$store.state.user);
                                if(!ret){
                                    return ret;
                                }
                            });
                        }
                    });
                })

                return ret;
            },
            handleSubmit() {
                if(!this.validateStep(this.steps[this.currentFormStep].id))
                    return false;
                this.errors = {};
                let steps = this.answers;
                let answers = [];

                steps = Object.keys(steps).map((key) => [key, steps[key]]);
                steps.forEach(([key, step]) => {
                    let answer = Object.keys(step).map((key) => [key, step[key]]);
                    answer.forEach(value => {
                        if(typeof value[1] === 'object' && value[1].length === 0 && this.isValid(value[0])){
                            this.errors[value[0]] = "Campo obrigatório"
                        }else if(value[1] === null || value[1] === "" && this.isValid(value[0])){
                            this.errors[value[0]] = "Campo obrigatório"
                        }
                    })
                });

                this.errors = Object.assign({}, this.errors);
                let errorsCount = Object.keys(this.errors).length;

                
                if(!this.accept_terms){
                    this.errors.accept_terms = ["Que Pena! Mas precisamos dessa concordância para realizar a análise da sua amostra. Quer concordar com o termo de consentimento?"];
                    return false;
                }else{
                    this.loading = true;
                    this.$emit('send', this.answers);
                }
            },
            fakeSubmit() {
                return null;
            }
        }
    }
</script>

<style scoped>
    @import "./form-steps.scss";
    @import "./responsive.css";
    .input-box {
        margin-bottom: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/FormSteps/FormSteps.vue